import slugify from 'react-slugify';
import {
  ESPN2Icon,
  ESPN3Icon,
  EspnIcon,
  ESPNPlusIcon,
  ESPNUIcon,
  FanduelIcon,
  FuboIcon,
  MLBcomIcon,
  MLBNetworkIcon,
  MLBTVIcon,
  SlingIcon,
} from '~/components/Icons';

/**
 * Returns the appropriate icon component for a broadcast name
 * @param name The name of the broadcast service
 * @param className Optional className to apply to the icon
 * @returns The icon component or the name string if no matching icon is found
 */
export function getBroadcastIcon(name: string, className?: string) {
  const brandName = slugify(name);

  // console.log('brandName', brandName);

  switch (brandName.toLowerCase()) {
    case 'espn':
      return <EspnIcon className="h-[16px] w-full" />;
    case 'espn2':
      return <ESPN2Icon className="h-[14px] w-full" />;
    case 'espn3':
      return <ESPN3Icon className="h-[14px] w-full" />;
    case 'espn-plus':
    case 'espn+':
      return <ESPNPlusIcon className="h-[14px] w-full" />;
    case 'espnu':
      return <ESPNUIcon className="h-[26px] w-full" />;
    case 'sling':
      return <SlingIcon className="h-[22px] w-full" />;
    case 'fubo':
      return <FuboIcon className="h-[22px] w-full" />;
    case 'mlb-network':
      return <MLBNetworkIcon className="h-[24px] w-full" />;
    case 'mlb-tv':
      return <MLBTVIcon className="h-[22px] w-full" />;
    case 'mlb-com':
    case 'mlbcom':
    case 'mlb.com':
      return <MLBcomIcon className="h-[22px] w-full" />;
    case 'fanduel':
    case 'fanduel-sports-network':
      return <FanduelIcon className="h-[26px] w-full" />;
    default:
      return name;
  }
}
